const About = () => {
    return (
        <div className="about-div">
            <h1>About Me</h1>
            <p>
                Hello! I'm Noah, a full-stack software engineer with a strong interest in backend development.
                I graduated from Georgia State University in 2018 with a degree in Computer Information Systems
                and a concentration in cybersecurity. Since then, I have been cutting my teeth attempting to
                pursue music full-time, but that hit a brick wall with the start of the Coronavirus Pandemic.
                Knowing I would need to make a change, I dusted off my degree and started applying for general
                I.T. positions. After quickly realizing a helpdesk position wouldn't be for me, I jumped back
                into learning how to code. Ten days into a python Udemy course I signed up for General Assembly
                under the guidance of multiple developer friends. Now 3 months and 500 hours later, I have a
                new passion and drive for software development. Learning how to code has brought back the
                feeling of being 10 years old first learning how to play the drums. When I'm away from my
                desk, I enjoy hanging out with my dog, cooking dope vegan food, and of course, my first love,
                playing drums.
            </p>
        </div>
    )
}
export default About